<template>
  <v-dialog :value.sync="open" width="600" @click:outside="close()">
    <v-card class="pa-3">
      <v-card-title class="headline" primary-title>
        {{ editing ? 'Edit' : 'Add' }} Resource Category
      </v-card-title>
      <v-card-text>
        <validation-observer ref="form">
          <v-form>
            <v-row>
              <v-col>
                <validation-provider
                  rules="required|max:255|min:3"
                  name="name"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    required
                    outlined
                    clearable
                    label="Name"
                    :error-messages="errors"
                    v-model="form.name"
                  ></v-text-field>
                </validation-provider>

                <validation-provider
                  rules="required|max:255|min:3"
                  name="display_name"
                  v-slot="{ errors }"
                >
                  <quill-editor
                    :error-messages="errors"
                    v-model="form.display_name"
                    :toolbar="[['bold', 'italic', 'underline']]"
                    id="quill-editor"
                    placeholder="Display Name"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  color="primary"
                  :loading="form.$busy"
                  :disabled="form.$busy"
                  @click.stop="save()"
                >
                  {{ editing ? 'Update' : 'Add' }} Category</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ResourceCategory from '@/models/ResourceCategory'
import QuillEditor from '@/components/QuillEditor'
import Form from '@/utils/form'

export default {
  components: {
    QuillEditor
  },
  props: {
    open: {
      type: Boolean
    },
    category: {
      type: ResourceCategory,
      default: null
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.newForm()
    }
  },
  methods: {
    newForm() {
      return new Form({
        name: '',
        display_name: '',
        order_column: 0,
        type: this.$route.name === 'training.resources' ? 2 : 1
      })
    },
    newResourceCategory() {
      return new ResourceCategory(this.form.$data())
    },
    async save() {
      this.form.$busy = true

      if (!(await this.$refs.form.validate())) {
        this.form.$busy = false
        return
      }

      try {
        let data = null
        if (this.editing) {
          this.category.name = this.form.name
          this.category.display_name = this.form.display_name
          data = await this.category.save()
        } else {
          data = (await this.newResourceCategory().save()).data
        }

        if (data) {
          this.form.$busy = false
          this.$emit('success', 0)
          this.close()
        }
      } catch (error) {
        this.form.$busy = false
        if (error.response && error.response.status === 422) {
          this.form.$setErrors(error.response.data.errors)
        }
      }
    },
    async close() {
      this.form = this.newForm()
      await this.$refs.form.reset()
      await this.$emit('close')
    },
    formatDisplayName() {
      // Wrap display_name with p tag if it was not formatted before
      const displayName = this.form.display_name
      if (!displayName.includes('<p>')) {
        this.form.display_name = `<p>${displayName}</p>`
      }
    }
  },

  watch: {
    editing(value) {
      if (value) {
        this.form.name = this.category.name
        this.form.display_name = this.category.display_name
      }
    },
    'form.name'(value) {
      this.formatDisplayName()
    }
  }
}
</script>

<style>
#quill-editor .ql-container {
  height: 50px !important;
}
</style>
